import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Star, Heart, Coffee, Battery, BookOpen, Shield, Clock, Users, TrendingUp, Sparkles, X, Award, Zap } from 'lucide-react';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { TestimonialCard } from '../components/TestimonialCard';
import { UrgencyBar } from '../components/UrgencyBar';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { FAQItem } from '../components/FAQItem';
// Image Constants
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/dewVrkp2eyig2sA64yZibw/ChatGPT_Image_7_ene_2026,_04_08_05.png';
const BONUS_1 = 'https://cdn.magicpatterns.com/uploads/mfKJZzymBMZvHAWb2tBB96/ChatGPT_Image_7_ene_2026,_05_05_26.png';
const BONUS_2 = 'https://cdn.magicpatterns.com/uploads/imBxFb8w7YvafTNbm8GHVy/ChatGPT_Image_7_ene_2026,_05_05_30.png';
const BONUS_3 = 'https://cdn.magicpatterns.com/uploads/5rsK6F3pniDQrqTkeFQ1Mq/ChatGPT_Image_7_ene_2026,_05_05_37.png';
const CHECKOUT_LINK = 'https://checkout2.rosetadigital.com/cart/46947956850866:1';
export function SalesPage() {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handlePurchase = () => {
    window.location.href = CHECKOUT_LINK;
  };
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="min-h-screen bg-[#FDFBF7] font-serif text-[#4A4A4A]" data-id="element-52">
      <UrgencyBar data-id="element-53" />
      <SocialProofPopup data-id="element-54" />

      {/* Hero Section - HOOK + AVATAR + DOLOR + CTA */}
      <header className="relative pt-12 pb-16 px-4 md:pt-20 md:pb-24 bg-gradient-to-b from-[#FDF8F3] to-[#FDFBF7]" data-id="element-55">
        <div className="max-w-7xl mx-auto" data-id="element-56">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-57">
            {/* Left: Text Content */}
            <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-58">
              <span className="inline-block text-xs font-bold tracking-widest text-[#D4915D] uppercase bg-[#D4915D]/10 px-4 py-2 rounded-full" data-id="element-59">
                GUÍA DE ALIVIO EMOCIONAL
              </span>

              {/* 1. HOOK (3 segundos) */}
              <h1 className="text-5xl md:text-7xl font-bold leading-tight" data-id="element-60">
                <span className="text-[#2C2C2C]" data-id="element-61">CÓMO SENTIRTE</span>
                <br data-id="element-62" />
                <span className="text-[#2C2C2C]" data-id="element-63">MEJOR SIN</span>
                <br data-id="element-64" />
                <span className="text-[#D4915D] italic" data-id="element-65">CAMBIAR NADA</span>
              </h1>

              {/* 2. AVATAR + 3. DOLOR */}
              <p className="text-2xl md:text-3xl text-gray-700 font-bold leading-tight" data-id="element-66">
                Para mujeres que siguen funcionando pero por dentro ya no dan
                más
              </p>

              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-67">
                Si vivís cansada, con culpa constante y la sensación de estar
                fallando aunque nadie te lo pida… esta guía es para vos.
              </p>

              {/* 4. CONTEXTO TEMPORAL */}
              <div className="inline-block bg-[#D4915D]/10 px-4 py-2 rounded-lg" data-id="element-68">
                <p className="text-sm text-[#D4915D] font-bold" data-id="element-69">
                  🗓️ Enero 2026 · No arranques otro año arrastrando el cansancio
                </p>
              </div>

              {/* Testimonial destacado */}
              <div className="bg-white p-5 rounded-xl border-l-4 border-[#D4915D] shadow-lg" data-id="element-70">
                <div className="flex gap-1 mb-2" data-id="element-71">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-72" />)}
                </div>
                <p className="text-gray-700 italic mb-2" data-id="element-73">
                  "Por fin alguien pone en palabras lo que siento. Lloré leyendo
                  las primeras páginas."
                </p>
                <p className="text-sm text-gray-600 font-bold" data-id="element-74">
                  - Laura, 41 años
                </p>
              </div>

              {/* 7. CTA PRINCIPAL */}
              <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-75">
                <motion.button whileHover={{
                scale: 1.05,
                y: -2
              }} whileTap={{
                scale: 0.95
              }} onClick={scrollToPurchase} className="bg-[#D4915D] hover:bg-[#C4824D] text-white px-10 py-5 rounded-full text-xl font-bold shadow-xl transition-all inline-flex items-center justify-center gap-3" data-id="element-76">
                  DESCARGAR AHORA
                  <ArrowRight className="w-6 h-6" data-id="element-77" />
                </motion.button>
              </div>

              {/* Trust badges */}
              <div className="flex flex-wrap gap-4 pt-4 text-sm text-gray-600" data-id="element-78">
                <div className="flex items-center gap-2" data-id="element-79">
                  <Shield className="w-5 h-5 text-green-600" data-id="element-80" />
                  <span data-id="element-81">Garantía 7 días</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-82">
                  <Users className="w-5 h-5 text-[#D4915D]" data-id="element-83" />
                  <span data-id="element-84">800+ mujeres</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-85">
                  <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-86" />
                  <span data-id="element-87">4.9/5 estrellas</span>
                </div>
              </div>
            </motion.div>

            {/* Right: Book Image with Badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.3,
            duration: 0.8
          }} className="relative" data-id="element-88">
              <div className="relative cursor-pointer group" onClick={scrollToPurchase} data-id="element-89">
                {/* 50% OFF Badge */}
                <div className="absolute -top-4 -right-4 bg-red-500 text-white px-6 py-3 rounded-full font-bold text-xl shadow-xl transform rotate-12 z-10 animate-pulse" data-id="element-90">
                  50% OFF HOY
                </div>

                <img src={MAIN_IMAGE} alt="Libro: Cómo Sentirte Mejor Sin Cambiar Nada" className="w-full rounded-2xl shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-91" />

                {/* Rating Badge - Bottom */}
                <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 bg-white rounded-2xl shadow-xl px-6 py-4 text-center min-w-[200px]" data-id="element-92">
                  <div className="flex justify-center gap-1 mb-2" data-id="element-93">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-94" />)}
                  </div>
                  <p className="text-sm font-bold text-gray-800" data-id="element-95">
                    800+ mujeres encontrando alivio
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </header>

      {/* 3. DOLOR - Una sección directa */}
      <section className="py-20 px-4 bg-white" data-id="element-96">
        <div className="max-w-4xl mx-auto text-center" data-id="element-97">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="space-y-8" data-id="element-98">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C2C2C] leading-tight" data-id="element-99">
              El cansancio que nadie ve
            </h2>

            <div className="space-y-6 text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-100">
              <p data-id="element-101">Desde afuera parecés estable. Responsable. Capaz.</p>
              <p data-id="element-102">
                Pero por dentro vivís cansada, con culpa constante y la
                sensación de estar fallando.
              </p>
              <p className="text-2xl font-bold text-[#D4915D]" data-id="element-103">
                No es cansancio físico. Es un cansancio del alma que nadie ve.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 5. SOLUCIÓN - Qué es y por qué funciona */}
      <section className="py-20 px-4 bg-[#FDFBF7]" data-id="element-104">
        <div className="max-w-4xl mx-auto text-center" data-id="element-105">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="space-y-8" data-id="element-106">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C2C2C] leading-tight" data-id="element-107">
              Alivio inmediato, sin esfuerzo
            </h2>

            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-108">
              Una guía suave que te da permiso para sentirte mal sin juzgarte.
              Sin terapia, sin procesos largos, sin transformarte en otra
              persona.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mt-12 max-w-2xl mx-auto" data-id="element-109">
              {[{
              icon: Heart,
              text: 'Reconocer qué te pasa',
              color: 'text-pink-500'
            }, {
              icon: Check,
              text: 'Validar tu cansancio',
              color: 'text-green-500'
            }, {
              icon: Coffee,
              text: 'Aflojar sin culpa',
              color: 'text-amber-500'
            }, {
              icon: Battery,
              text: 'Descansar emocionalmente',
              color: 'text-blue-500'
            }].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-110">
                  <item.icon className={`w-7 h-7 ${item.color}`} data-id="element-111" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-112">
                    {item.text}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>

      {/* 6. BENEFICIOS TANGIBLES - Qué cambia */}
      <section className="py-20 px-4 bg-white" data-id="element-113">
        <div className="max-w-4xl mx-auto text-center" data-id="element-114">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="space-y-8" data-id="element-115">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C2C2C] leading-tight" data-id="element-116">
              Lo que vas a sentir
            </h2>

            <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-117">
              {['Menos culpa por descansar', 'Menos ruido mental', 'Alivio inmediato', 'Validación y permiso'].map((benefit, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-center gap-3 bg-[#FDF8F3] p-5 rounded-xl text-left" data-id="element-118">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-119" />
                  <span className="text-lg text-gray-700 font-medium" data-id="element-120">
                    {benefit}
                  </span>
                </motion.div>)}
            </div>

            <p className="text-xl text-gray-600 italic pt-4" data-id="element-121">
              Aunque nada cambie afuera, vos vas a sentir la diferencia por
              dentro.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Qué Incluye - BREVE */}
      <section className="py-20 px-4 bg-[#FDFBF7]" data-id="element-122">
        <div className="max-w-5xl mx-auto" data-id="element-123">
          <div className="text-center mb-12" data-id="element-124">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-[#2C2C2C]" data-id="element-125">
              Qué incluye
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-126">
            {[{
            number: '01',
            title: 'Reconocer',
            description: 'Entender tu cansancio sin juzgarte'
          }, {
            number: '02',
            title: 'Validar',
            description: 'Descubrir que no estás sola'
          }, {
            number: '03',
            title: 'Aflojar',
            description: 'Bajar la exigencia sin culpa'
          }, {
            number: '04',
            title: 'Pausar',
            description: 'Prácticas que te devuelven el respiro'
          }, {
            number: '05',
            title: 'Descansar',
            description: 'Crear espacios de calma'
          }, {
            number: '06',
            title: 'Volver',
            description: 'Reconectar con vos misma'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-127">
                <div className="w-12 h-12 bg-[#D4915D] text-white rounded-full flex items-center justify-center text-xl font-bold mb-3" data-id="element-128">
                  {item.number}
                </div>
                <h3 className="text-lg font-bold mb-2 text-[#2C2C2C]" data-id="element-129">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-130">{item.description}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-131">
            <button onClick={scrollToPurchase} className="bg-[#D4915D] hover:bg-[#C4824D] text-white px-10 py-5 rounded-full text-xl font-bold shadow-xl transition-all inline-flex items-center gap-3" data-id="element-132">
              ACCEDER AHORA
              <ArrowRight className="w-6 h-6" data-id="element-133" />
            </button>
          </div>
        </div>
      </section>

      {/* Value Comparison */}
      <section className="py-20 px-4 bg-[#FDFBF7]" data-id="element-134">
        <div className="max-w-5xl mx-auto" data-id="element-135">
          <div className="text-center mb-16" data-id="element-136">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-[#2C2C2C]" data-id="element-137">
              Compará tu inversión
            </h2>
            <p className="text-xl text-gray-600" data-id="element-138">
              ¿Qué opción tiene más sentido para vos?
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-139">
            {/* Traditional Option */}
            <div className="bg-gray-50 p-8 rounded-2xl border-2 border-gray-200" data-id="element-140">
              <h3 className="text-2xl font-bold mb-6 text-gray-800" data-id="element-141">
                Terapia tradicional
              </h3>
              <div className="space-y-4 mb-6" data-id="element-142">
                {['Costo: $8,000-$12,000 por sesión', 'Mínimo 8-12 sesiones', 'Total: $64,000-$144,000', 'Requiere agenda y traslado', 'Proceso de meses', 'Confrontación emocional intensa'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-143">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-144" />
                    <span className="text-gray-700" data-id="element-145">{item}</span>
                  </div>)}
              </div>
              <div className="text-center pt-4 border-t border-gray-300" data-id="element-146">
                <p className="text-3xl font-bold text-gray-600" data-id="element-147">$64,000+</p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-148">Inversión mínima</p>
              </div>
            </div>

            {/* Your Product */}
            <div className="bg-gradient-to-br from-[#FDF8F3] to-white p-8 rounded-2xl border-4 border-[#D4915D] relative shadow-xl" data-id="element-149">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#D4915D] text-white px-6 py-2 rounded-full font-bold text-sm" data-id="element-150">
                ✨ MEJOR OPCIÓN
              </div>

              <h3 className="text-2xl font-bold mb-6 text-[#2C2C2C]" data-id="element-151">
                Esta guía
              </h3>
              <div className="space-y-4 mb-6" data-id="element-152">
                {['Inversión única: $19,990', 'Acceso inmediato y para siempre', 'Leés a tu ritmo, cuando querés', 'Sin agenda ni traslados', 'Resultados desde el primer día', 'Alivio sin confrontación'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-153">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-154" />
                    <span className="text-gray-700 font-medium" data-id="element-155">{item}</span>
                  </div>)}
              </div>
              <div className="text-center pt-4 border-t border-[#D4915D]/30" data-id="element-156">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-157">
                  <p className="text-4xl font-bold text-[#D4915D]" data-id="element-158">$19,990</p>
                  <p className="text-2xl text-gray-400 line-through" data-id="element-159">$39,990</p>
                </div>
                <p className="text-sm text-gray-600" data-id="element-160">
                  Pago único • 50% OFF HOY
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-161">
            <button onClick={scrollToPurchase} className="bg-[#D4915D] hover:bg-[#C4824D] text-white px-12 py-6 rounded-full text-2xl font-bold shadow-xl transition-all inline-flex items-center gap-3" data-id="element-162">
              ELEGIR LA MEJOR OPCIÓN
              <ArrowRight className="w-7 h-7" data-id="element-163" />
            </button>
          </div>
        </div>
      </section>

      {/* Bonuses with Urgency */}
      <section className="py-20 px-4 bg-gradient-to-br from-[#D4915D]/10 to-[#FDF8F3]" data-id="element-164">
        <div className="max-w-6xl mx-auto" data-id="element-165">
          <div className="text-center mb-12" data-id="element-166">
            <motion.div animate={{
            scale: [1, 1.05, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="inline-block bg-red-500 text-white px-8 py-3 rounded-full font-bold text-lg mb-6 shadow-xl" data-id="element-167">
              🔥 SOLO POR HOY
            </motion.div>

            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-[#2C2C2C]" data-id="element-168">
              + 3 Bonos GRATIS
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-169">
            {[{
            img: BONUS_1,
            title: 'Test de Cansancio',
            value: '$9,990'
          }, {
            img: BONUS_2,
            title: 'Ritual 10 Min',
            value: '$9,990'
          }, {
            img: BONUS_3,
            title: 'Guía Volver a Vos',
            value: '$9,990'
          }].map((bonus, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15
          }} className="bg-white rounded-2xl overflow-hidden shadow-xl" data-id="element-170">
                <div className="relative" data-id="element-171">
                  <div className="absolute top-4 left-4 bg-green-500 text-white px-4 py-2 rounded-full font-bold text-sm uppercase shadow-lg z-10" data-id="element-172">
                    GRATIS
                  </div>
                  <img src={bonus.img} alt={bonus.title} className="w-full h-56 object-cover" data-id="element-173" />
                </div>
                <div className="p-6 text-center" data-id="element-174">
                  <h3 className="font-bold text-lg text-[#2C2C2C] mb-2" data-id="element-175">
                    {bonus.title}
                  </h3>
                  <span className="text-[#D4915D] font-bold text-lg" data-id="element-176">
                    {bonus.value}
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center bg-white p-10 rounded-3xl shadow-2xl max-w-2xl mx-auto border-4 border-[#D4915D]" data-id="element-177">
            <p className="text-2xl text-gray-600 mb-3" data-id="element-178">Valor total:</p>
            <p className="text-6xl font-bold text-gray-400 line-through mb-4" data-id="element-179">
              $29,970
            </p>
            <p className="text-7xl font-bold text-green-600 mb-6" data-id="element-180">¡GRATIS!</p>

            <button onClick={scrollToPurchase} className="bg-[#D4915D] hover:bg-[#C4824D] text-white px-12 py-6 rounded-full text-2xl font-bold shadow-xl transition-all inline-flex items-center gap-3 w-full justify-center" data-id="element-181">
              QUIERO LOS BONOS GRATIS
              <Zap className="w-7 h-7" data-id="element-182" />
            </button>
          </motion.div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-20 px-4 bg-white" data-id="element-183">
        <div className="max-w-4xl mx-auto" data-id="element-184">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="bg-gradient-to-br from-green-50 to-emerald-50 p-12 rounded-3xl border-2 border-green-200 text-center" data-id="element-185">
            <Shield className="w-20 h-20 text-green-600 mx-auto mb-6" data-id="element-186" />
            <h2 className="text-4xl font-bold mb-6 text-gray-800" data-id="element-187">
              Garantía de 7 días
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-188">
              Si en 7 días sentís que no te ayudó, te devolvemos el 100% de tu
              dinero. Sin preguntas.
            </p>
            <div className="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto" data-id="element-189">
              <p className="text-lg font-bold text-green-700 mb-2" data-id="element-190">
                ✓ Cero riesgo para vos
              </p>
              <p className="text-gray-600" data-id="element-191">
                Probala 7 días. Si no te sirve, recuperás tu inversión.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Final CTA */}
      <section id="purchase-section" className="py-24 px-4 bg-gradient-to-br from-[#2C2C2C] via-[#3A3A3A] to-[#2C2C2C] text-white relative overflow-hidden" data-id="element-192">
        <div className="absolute top-0 left-0 w-full h-full opacity-10" data-id="element-193">
          <div className="absolute top-20 left-20 w-64 h-64 rounded-full bg-[#D4915D] blur-3xl" data-id="element-194"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 rounded-full bg-[#D4915D] blur-3xl" data-id="element-195"></div>
        </div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-196">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-12" data-id="element-197">
            <h2 className="text-5xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-198">
              Date este espacio
            </h2>
            <p className="text-2xl text-gray-300 mb-4 max-w-3xl mx-auto" data-id="element-199">
              Si llegaste hasta acá, ya sabés que lo necesitás.
            </p>
          </motion.div>

          <div className="bg-white text-gray-800 rounded-3xl p-10 md:p-12 shadow-2xl max-w-3xl mx-auto" data-id="element-200">
            <div className="text-center mb-8" data-id="element-201">
              <div className="flex items-center justify-center gap-4 mb-4" data-id="element-202">
                <span className="text-6xl font-bold text-[#D4915D]" data-id="element-203">
                  $19,990
                </span>
                <span className="text-4xl text-gray-400 line-through" data-id="element-204">
                  $39,990
                </span>
              </div>
              <div className="inline-block bg-red-500 text-white px-6 py-2 rounded-full font-bold text-lg mb-6" data-id="element-205">
                50% OFF - SOLO HOY
              </div>
            </div>

            {/* Lo que incluye tu compra */}
            <div className="bg-[#FDF8F3] p-6 rounded-2xl mb-8 border-2 border-[#D4915D]/20" data-id="element-206">
              <p className="font-bold text-xl mb-4 text-center text-[#2C2C2C]" data-id="element-207">
                Tu compra incluye:
              </p>
              <div className="space-y-3" data-id="element-208">
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg" data-id="element-209">
                  <BookOpen className="w-6 h-6 text-[#D4915D] flex-shrink-0 mt-0.5" data-id="element-210" />
                  <div data-id="element-211">
                    <p className="font-bold text-gray-800" data-id="element-212">
                      Guía completa en PDF
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-213">
                      Cómo Sentirte Mejor Sin Cambiar Nada
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg" data-id="element-214">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-215" />
                  <div data-id="element-216">
                    <p className="font-bold text-gray-800" data-id="element-217">
                      Bonus 1: Test de Cansancio Emocional
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-218">
                      Valor: $9,990 - GRATIS
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg" data-id="element-219">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-220" />
                  <div data-id="element-221">
                    <p className="font-bold text-gray-800" data-id="element-222">
                      Bonus 2: Ritual de 10 Minutos
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-223">
                      Valor: $9,990 - GRATIS
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg" data-id="element-224">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-225" />
                  <div data-id="element-226">
                    <p className="font-bold text-gray-800" data-id="element-227">
                      Bonus 3: Guía Volver a Vos
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-228">
                      Valor: $9,990 - GRATIS
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200 text-center" data-id="element-229">
                <p className="text-sm text-gray-600" data-id="element-230">
                  Valor total: <span className="line-through" data-id="element-231">$49,960</span>
                </p>
                <p className="text-2xl font-bold text-[#D4915D]" data-id="element-232">
                  Hoy: $19,990
                </p>
              </div>
            </div>

            <motion.button whileHover={{
            scale: 1.02,
            y: -2
          }} whileTap={{
            scale: 0.98
          }} onClick={handlePurchase} className="w-full bg-[#D4915D] hover:bg-[#C4824D] text-white py-7 rounded-full text-3xl font-bold shadow-2xl transition-all flex items-center justify-center gap-4 mb-6" data-id="element-233">
              DESCARGAR AHORA
              <ArrowRight className="w-8 h-8" data-id="element-234" />
            </motion.button>

            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-600" data-id="element-235">
              <span className="flex items-center gap-2" data-id="element-236">
                <Shield className="w-5 h-5 text-green-600" data-id="element-237" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-2" data-id="element-238">
                <Zap className="w-5 h-5 text-[#D4915D]" data-id="element-239" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-240">
                <Award className="w-5 h-5 text-yellow-500" data-id="element-241" />
                Pago seguro
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-white" data-id="element-242">
        <div className="max-w-6xl mx-auto" data-id="element-243">
          <div className="text-center mb-16" data-id="element-244">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-[#2C2C2C]" data-id="element-245">
              Lo que dicen quienes ya lo tienen
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-246">
            {[{
            initial: 'M',
            name: 'María C.',
            age: 34,
            location: 'Buenos Aires',
            quote: 'Por fin alguien pone en palabras lo que siento. No necesitaba más consejos, necesitaba validación.'
          }, {
            initial: 'L',
            name: 'Laura S.',
            age: 41,
            location: 'Córdoba',
            quote: 'Lloré leyendo las primeras páginas. Sentí que me sacaban una mochila de encima.'
          }, {
            initial: 'S',
            name: 'Silvana R.',
            age: 38,
            location: 'Rosario',
            quote: 'Este libro me enseñó que a veces la respuesta es soltar, no esforzarse más.'
          }, {
            initial: 'A',
            name: 'Andrea M.',
            age: 29,
            location: 'Mendoza',
            quote: 'Lo leo cada vez que la exigencia me gana. Es mi refugio.'
          }, {
            initial: 'P',
            name: 'Patricia L.',
            age: 45,
            location: 'La Plata',
            quote: 'No es el típico libro que te dice "sé feliz". Te acompaña a transitar el cansancio.'
          }, {
            initial: 'V',
            name: 'Valeria G.',
            age: 36,
            location: 'Mar del Plata',
            quote: 'La mejor inversión en mí misma que hice en años.'
          }].map((testimonial, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-[#FDFBF7] p-6 rounded-2xl border border-gray-100" data-id="element-247">
                <div className="flex gap-1 mb-4" data-id="element-248">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-249" />)}
                </div>
                <div className="flex items-center gap-4 mb-4" data-id="element-250">
                  <div className="w-12 h-12 rounded-full bg-[#D4915D] flex items-center justify-center text-white font-bold text-xl" data-id="element-251">
                    {testimonial.initial}
                  </div>
                  <div data-id="element-252">
                    <p className="font-bold text-[#2C2C2C]" data-id="element-253">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-254">
                      {testimonial.age} años • {testimonial.location}
                    </p>
                  </div>
                </div>
                <p className="text-gray-700" data-id="element-255">"{testimonial.quote}"</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-[#FDFBF7]" data-id="element-256">
        <div className="max-w-4xl mx-auto" data-id="element-257">
          <div className="text-center mb-16" data-id="element-258">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-[#2C2C2C]" data-id="element-259">
              Preguntas frecuentes
            </h2>
          </div>

          <div className="space-y-4" data-id="element-260">
            <FAQItem question="¿Cómo lo recibo?" answer="Por email, inmediatamente después del pago. Acceso desde cualquier dispositivo." data-id="element-261" />
            <FAQItem question="¿Es un pago único?" answer="Sí. Pagás una vez $19,990 y es tuyo para siempre. Sin suscripciones." data-id="element-262" />
            <FAQItem question="¿Qué formato tiene?" answer="PDF optimizado para celular, tablet o computadora. También podés imprimirlo." data-id="element-263" />
            <FAQItem question="¿Cuánto tiempo lleva leerlo?" answer="Podés leerlo en una tarde o de a poco. No hay forma correcta." data-id="element-264" />
            <FAQItem question="¿Qué pasa si no me sirve?" answer="7 días de garantía. Te devolvemos el 100% sin preguntas." data-id="element-265" />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-white py-12 px-4 text-center" data-id="element-266">
        <div className="max-w-2xl mx-auto opacity-80" data-id="element-267">
          <p className="mb-4 text-lg font-serif italic" data-id="element-268">
            "No te empujes, date espacio para volver a vos."
          </p>
          <div className="w-16 h-px bg-white/20 mx-auto my-6" data-id="element-269"></div>
          <p className="text-sm text-gray-400" data-id="element-270">
            © 2024 Cómo Sentirte Mejor Sin Cambiar Nada
          </p>
        </div>
      </footer>
    </div>;
}